import Section from '../../../components/Main/Section/Section';
import React, { useContext, useEffect, useState } from 'react';
import { Box, Button, LinearProgress, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ContentContainer from '../../../components/Containers/ContentContainer';
import { AuthContext } from '../../../providers/AuthProvider';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import LeftContainer from '../../../components/Containers/LeftContainer';
import ReviewAiService from '../../../services/ReviewAiService';

const AiReview = () => {
  const { hasRole } = useContext(AuthContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [text, setText] = useState<string>('');
  const theme = useTheme();
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();

  const sanitizeHtml = (html: string) => {
    let sanitized = html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, ''); // Remove script tags
    sanitized = sanitized.replace(/javascript:/gi, ''); // Remove javascript: URLs
    return sanitized;
  };

  useEffect(() => {
    const controller = new AbortController();

    (async () => {
      setLoading(true);
      const response = await ReviewAiService.analyzeMonitoring(params.id || '', setLoading);
      let content = response.text;

      // extract html
      const htmlStart = '```html\n';
      if (content.startsWith(htmlStart)) {
        content = content.substring(htmlStart.length);
        content = content.replaceAll('```', '');
      }

      // extract body
      const regexb = /<body[^>]*>(.*?)<\/body>/is;
      const matchb = content.match(regexb);
      if (matchb && matchb[1] !== undefined) {
        content = matchb[1];
      }

      content = sanitizeHtml(content);
      setText(content);
    })();

    return () => {
      controller.abort();
    };
  }, []);

  return hasRole('can-use-ai') ? (
    <Section>
      <ContentContainer>
        <LeftContainer>
          {loading ? (
            <Box>
              <LinearProgress sx={{ mt: theme.spacing(1), mb: theme.spacing(2) }} />
            </Box>
          ) : (
            <>
              <div dangerouslySetInnerHTML={{ __html: text }} />
            </>
          )}
          <div>
            <Button
              variant="contained"
              onClick={() => navigate('/monitoring/platforms/')}
              startIcon={<ArrowBack />}
            >
              {t('back')}
            </Button>
          </div>
        </LeftContainer>
      </ContentContainer>
    </Section>
  ) : null;
};

export default AiReview;
